import { io } from "socket.io-client";
import api from "./api";

let sharedSocket = null;
let liveHolds = 0;
let resumeBound = false;
const binListeners = new Set();

function socketOrigin() {
  const baseURL = api.defaults.baseURL || "";
  return baseURL.replace(/\/?api\/?$/i, "") || baseURL;
}

function bindResume() {
  if (resumeBound || typeof document === "undefined") return;
  resumeBound = true;
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && sharedSocket && !sharedSocket.connected) {
      sharedSocket.connect();
    }
  });
}

function ensureSocket() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  if (sharedSocket) {
    sharedSocket.auth = { token };
    return sharedSocket;
  }

  sharedSocket = io(socketOrigin(), {
    auth: { token },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: 6,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 30000,
    timeout: 10000,
  });

  sharedSocket.on("bin:updated", (payload) => {
    const bin = payload?.bin ?? null;
    binListeners.forEach((fn) => {
      try {
        fn(bin);
      } catch (error) {
        console.error("bin listener error:", error);
      }
    });
  });

  sharedSocket.io.on("reconnect_failed", () => {
    setTimeout(() => {
      if (sharedSocket && !sharedSocket.connected && document.visibilityState === "visible") {
        sharedSocket.connect();
      }
    }, 120000);
  });

  bindResume();
  return sharedSocket;
}

function releaseIfIdle() {
  if (liveHolds === 0 && binListeners.size === 0 && sharedSocket) {
    sharedSocket.disconnect();
    sharedSocket = null;
  }
}

export function getLiveSocket() {
  return ensureSocket();
}

export function holdLiveSocket() {
  liveHolds += 1;
  const socket = ensureSocket();
  return () => {
    liveHolds = Math.max(0, liveHolds - 1);
    if (!socket) return;
    releaseIfIdle();
  };
}

export function subscribeBinUpdates(onBin) {
  const token = localStorage.getItem("token");
  if (!token) return () => {};

  ensureSocket();
  binListeners.add(onBin);

  return () => {
    binListeners.delete(onBin);
    releaseIfIdle();
  };
}
